import * as React from "react";
import axios from "../axios";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import { useMediaQuery, useTheme } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import * as moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

import { registerLicense } from "@syncfusion/ej2-base";

registerLicense(
  "ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdEVjXntdcHNVQGda;MzExNjY5OUAzMjM0MmUzMDJlMzBFZmo4T0hTeUlZQjB3cjhSVFkvT0tLUDFUVEtMZU9NQXljVHk3dXloYnJ3PQ=="
);

const headCells = [
  {
    id: "patient_id",
    numeric: true,
    disablePadding: false,
    label: "Patient ID",
  },
  {
    id: "assessment_id",
    numeric: true,
    disablePadding: false,
    label: "Assessment ID",
  },
  {
    id: "payment_status",
    numeric: true,
    disablePadding: false,
    label: "Payment Status",
  },
  {
    id: "createdOn",
    numeric: true,
    disablePadding: false,
    label: "Created On",
  },
  { id: "amount", numeric: true, disablePadding: false, label: "Amount" },
  {
    id: "payment_method",
    numeric: true,
    disablePadding: false,
    label: "Payment Mode",
  },
];
function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, isMobile } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) =>
          headCell.id !== "assessment_id" || !isMobile ? (
            <TableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ fontWeight: "bold", fontSize: "14px" }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ) : null
        )}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

function EnhancedTableToolbar({
  cash,
  onlineCash,
  totalAmount,
  onDateChange,
  onExport,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [dateRange, setDateRange] = React.useState({
    startDate: moment().subtract(1, "week").toDate(),
    endDate: moment().toDate(),
  });
  const [initialRender, setIntialRender] = React.useState(true);
  const [dates1, setDates1] = React.useState("");
  const [dates2, setDates2] = React.useState("");
  const [selectedOption, setSelectedOption] = React.useState("");
  const [showDatePicker, setShowDatePicker] = React.useState(false);

  React.useEffect(() => {
    const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
    const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
    if (initialRender) {
      // fetchData();
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
      onDateChange(startDate1, endDate1);
      setIntialRender(false);
    }
  }, []);

  React.useEffect(() => {
    // debugger
    const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
    const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
    if (!initialRender) {
      // fetchData();
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
      onDateChange(startDate1, endDate1);
      setIntialRender(false);
    }
  }, [dateRange.startDate, dateRange.endDate]);
  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Call respective handler functions based on selected option
    if (value === "1 week") {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === "1 day") {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === "1 month") {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === "1 year") {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === "custom") {
      setShowDatePicker(true);
    }
  };

  const oneWeekHandler = () => {
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate(new Date(newStartdate.subtract(7, "day").valueOf()));
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(7, "day").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });

    setSelectedOption("1 week");
  };
  const oneMonthHandler = () => {
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate(new Date(newStartdate.subtract(1, "month").valueOf()));
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(1, "month").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });

    setSelectedOption("1 month");
  };
  const oneDayHandler = () => {
    setSelectedOption("1 day");
    const today = moment().startOf("day").toDate();
    // setStartDate(today); // Set start date to today
    // setEndDate(today); // Set end date to today
    setDateRange({ startDate: today, endDate: today });
  };
  const oneYearHandler = () => {
    setSelectedOption("1 year");
    const startDate = moment().subtract(1, "year").toDate();
    const endDate = moment().toDate();
    // setStartDate(startDate); // Set start date 1 year ago
    // setEndDate(endDate);
    setDateRange({ startDate: startDate, endDate: endDate }); // Set end date to end of this year
  };

  const handleRangeSelected = (args) => {
    // Ensure args.value is not null and has at least two elements (start and end date)
    if (args && args.value && args.value.length === 2) {
      const startDate1 = args.value[0];
      const endDate1 = args.value[1];

      const startDate2 = moment(startDate1).format("YYYY-MM-DD");
      const endDate2 = moment(endDate1).format("YYYY-MM-DD");

      setDateRange({ startDate: startDate2, endDate: endDate2 });
      // Optional: setStartDate(startDate2);
      // Optional: setEndDate(endDate2);
      setSelectedOption(""); // Reset selected option
    } else {
      // Handle the case when args.value is invalid or incomplete
      console.error("Invalid date range selected:", args);
    }
  };

  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === "custom") {
      ref.show();
    }
  };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        display: "flex",
        gap: isMobile ? 0 : 6,
        alignItems: "center",
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: isMobile ? "space-between" : "flex-start",
          alignItems: "center",
          width: isMobile ? "100%" : "auto",
          mb: isMobile ? 2 : 0,
          marginTop: "8px",
        }}
      >
        <Typography
          sx={{
            color: "#FF7D00",
            fontSize: "18px",
            flexGrow: isMobile ? 1 : 0,
          }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Summary
        </Typography>
        <div
          className=""
          style={{
            marginLeft: isMobile ? "0" : "15px",
          }}
        ></div>
        <div className="dateSelection">
          <select
            className="selectDate"
            id="duration"
            value={selectedOption}
            onChange={handleChange}
          >
            <option>Date Range</option>
            <option value="1 day">1 Day</option>
            <option value="1 week">1 Week</option>
            <option value="1 month">1 Month</option>
            <option value="1 year">1 Year</option>
            <option value="custom" key="">
              Custom
            </option>
          </select>
          {showDatePicker && (
            <div className="dateRangePicker">
              <DateRangePickerComponent
                id="daterangepicker"
                placeholder="Select a range"
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                showClearButton={false}
                onChange={handleRangeSelected}
                ref={(ref) => handleDateRangePickerRef(ref)}
              />
            </div>
          )}
          <div className="dates-container">
            <p className="dates">{moment(dates1).format("DD-MM-YYYY")} </p>
            <p className="dates">to</p>
            <p className="dates">{moment(dates2).format("DD-MM-YYYY")} </p>
          </div>
        </div>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: isMobile ? "" : "flex-start",
          width: isMobile ? "100%" : "auto",
          gap: isMobile ? 3 : 6,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            variant="body1"
            sx={{ color: "#000000B2", fontSize: "15px !important" }}
          >
            Cash
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#FCB514",
              fontSize: "15px !important",
              fontWeight: 600,
            }}
          >
            {cash}₹
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            variant="body1"
            sx={{ color: "#000000B2", fontSize: "15px !important" }}
          >
            Online
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#82BF25",
              fontSize: "15px !important",
              fontWeight: 600,
            }}
          >
            {onlineCash}₹
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            variant="body1"
            sx={{ color: "#000000B2", fontSize: "15px !important" }}
          >
            Total Amount
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#505F79",
              fontSize: "15px !important",
              fontWeight: 600,
            }}
          >
            {cash + onlineCash}₹
          </Typography>
        </Box>
        <Box>
          <button
            style={{
              fontFamily: "Roboto",
              fontSize: "13px",
              padding: "10px",
              paddingLeft: "12px",
              cursor: "pointer",
              marginRight: "20px",
              width: "60px",
              color: "white",
              backgroundColor: "#ff950a",
              borderRadius: "6px",
            }}
            onClick={() => onExport(dateRange)}
          >
            Export
          </button>
        </Box>
      </Box>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  cash: PropTypes.number.isRequired,
  onlineCash: PropTypes.number.isRequired,
  totalAmount: PropTypes.number.isRequired,
  onDateChange: PropTypes.func.isRequired,
};

export default function EnhancedTable(props) {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rows, setRows] = React.useState([]);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [selectedCash, setSelectedCash] = React.useState(0);
  const [selectedOnline, setSelectedOnline] = React.useState(0);
  const [selectedTotal, setSelectedTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const formatDate = (dateString) => {
    // Check if the dateString is valid
    const date = new Date(dateString);

    // If the date is invalid, return an empty string or a fallback value
    if (isNaN(date)) {
      console.error("Invalid date:", dateString);
      return ""; // Or return a fallback value like "Invalid Date"
    }

    return new Intl.DateTimeFormat("en-GB").format(date);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/user_payment_entry`, {
          headers: {
            accessToken: localStorage.accessToken,
          },
        });
        if (response.data.message) {
          setRows([]);
        } else {
          // debugger;
          const data = response.data;
          let cashSum = 0;
          let onlineSum = 0;

          const formattedData = data.map((item) => {
            const paymentMethod =
              item.payload.payment_method?.toLowerCase() || "-";
            let amount = parseInt(item.amount, 10);

            if (
              paymentMethod === "cash" &&
              item.payment_status?.toLowerCase() === "completed"
            ) {
              cashSum += amount;
            } else if (
              paymentMethod === "online" &&
              item.payment_status?.toLowerCase() === "completed"
            ) {
              onlineSum += amount;
            }

            return {
              id: item.id,
              patient_id: item.patient_id,
              assessment_id: item.assessment_id,
              payment_status: item.payment_status,
              createdOn: formatDate(item.createdOn),
              updated_on: formatDate(item.updated_on),
              order_id: item.order_id,
              amount: amount,
              payment_method: paymentMethod,
            };
          });
          // debugger;
          setLoading(true);
          setRows(formattedData);
          setFilteredRows(formattedData);

          // Set initial start and end dates based on fetched data
          // debugger
          let newStartdate = moment(new Date());
          let newEnddate = moment(new Date());
          const maxDate = new Date(newEnddate.add(1, "day").valueOf()); // Current date

          const minDate = new Date(newStartdate.subtract(7, "day").valueOf()); // Clone maxDate

          console.log("Start Date (1 week ago):", minDate);
          console.log("End Date (Tomorrow):", maxDate);

          // Apply the range
          // Pass formattedData directly
          handleDateChange(minDate, maxDate, formattedData);
          setLoading(false);

          props.handlePayments(
            cashSum + onlineSum,
            formattedData.length,
            cashSum,
            onlineSum
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDateChange = (startDate, endDate, data = rows) => {
    setPage(0);
    if (!startDate || !endDate) {
      setFilteredRows(data);
      setSelectedCash(0);
      setSelectedOnline(0);
      setSelectedTotal(0);
    } else {
      const filtered = data.filter((row) => {
        const rowDate = moment(row.createdOn, "DD/MM/YYYY").toDate();
        return rowDate >= new Date(startDate) && rowDate <= new Date(endDate);
      });

      const cashSum = filtered
        .filter(
          (row) =>
            row.payment_method.toLowerCase() === "cash" &&
            row.payment_status.toLowerCase() === "completed"
        )
        .reduce((acc, row) => acc + row.amount, 0);

      const onlineSum = filtered
        .filter(
          (row) =>
            row.payment_method.toLowerCase() === "online" &&
            row.payment_status.toLowerCase() === "completed"
        )
        .reduce((acc, row) => acc + row.amount, 0);

      const total = filtered.reduce((acc, row) => acc + row.amount, 0);

      setFilteredRows(filtered);
      setSelectedCash(cashSum);
      setSelectedOnline(onlineSum);
      setSelectedTotal(total);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredRows.length) : 0;

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const visibleRows = React.useMemo(
    () =>
      stableSort(
        filteredRows.length ? filteredRows : [],
        getComparator(order, orderBy)
      ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage, rows, filteredRows]
  );

  const handleExport = (date) => {
    const csvData = [];

    // Add the header row
    csvData.push(headCells.map((cell) => cell.label).join(","));

    // Add the data rows
    filteredRows.forEach((row) => {
      const rowData = headCells.map((cell) => row[cell.id]);
      csvData.push(rowData.join(","));
    });

    // Create a blob from the CSV data
    const blob = new Blob([csvData.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    // Create a link and trigger the download
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute(
      "download",
      `${date === null ? "table-data" : formatDate(date)}.csv`
    );
    a.click();
  };

  return (
    <Box>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <EnhancedTableToolbar
          cash={selectedCash}
          onlineCash={selectedOnline}
          totalAmount={selectedTotal}
          onDateChange={handleDateChange}
          onExport={handleExport}
        />
        <TableContainer>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "60vh",
              }}
            >
              <ClipLoader color={"#fd8c00"} size={30} />
            </Box>
          ) : (
            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                isMobile={isMobile}
              />
              <TableBody>
                {visibleRows.length > 0 ? (
                  visibleRows.map((row) => (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.id}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell align="left" sx={{ fontSize: "13px" }}>
                        {row.patient_id}
                      </TableCell>
                      {!isMobile && (
                        <TableCell align="left" sx={{ fontSize: "13px" }}>
                          {row.assessment_id}
                        </TableCell>
                      )}
                      <TableCell align="left" sx={{ fontSize: "13px" }}>
                        {row.payment_status}
                      </TableCell>
                      <TableCell align="left" sx={{ fontSize: "13px" }}>
                        {row.createdOn}
                      </TableCell>
                      <TableCell align="left" sx={{ fontSize: "13px" }}>
                        {row.amount}
                      </TableCell>
                      <TableCell align="left" sx={{ fontSize: "13px" }}>
                        {row.payment_method}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                )}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length ? filteredRows.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    </Box>
  );
}
